import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_category = createAsyncThunk(
  'product/get_category',
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/get-categorys')
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const get_categories = createAsyncThunk(
  'product/get_categories',
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/get-categories')
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method
export const get_products = createAsyncThunk(
  'product/get_products',
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/get-products')

      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const price_range_product = createAsyncThunk(
  'product/price_range_product',
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/price-range-latest-product')

      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method
// export const query_products = createAsyncThunk(
//   'product/query_products',
//   async (query, { fulfillWithValue, rejectWithValue }) => {
//     try {
//       const {
//         categoryId,
//         // subCategoryId,
//         rating,
//         low,
//         high,
//         sortPrice,
//         pageNumber,
//         searchValue,
//       } = query

//       // Construct query parameters only if they exist
//       const params = new URLSearchParams()

//       if (categoryId) params.append('categoryId', categoryId)
//       // if (subCategoryId) params.append('subCategoryId', subCategoryId)
//       if (rating) params.append('rating', rating)
//       if (low) params.append('lowPrice', low)
//       if (high) params.append('highPrice', high)
//       if (sortPrice) params.append('sortPrice', sortPrice)
//       if (pageNumber) params.append('pageNumber', pageNumber)
//       if (searchValue) params.append('searchValue', searchValue)

//       // Construct URL with query parameters
//       const queryString = params.toString()

//       const { data } = await api.get(`/home/query-products?${queryString}`)

//       return fulfillWithValue(data)
//     } catch (error) {
//       console.log(error.response) // Log the error response for debugging
//       return rejectWithValue(error.response.data) // Return error message if request fails
//     }
//   }
// )

// End Method
export const query_products = createAsyncThunk(
  'product/query_products',
  async (query, { fulfillWithValue, rejectWithValue }) => {
    try {
      const params = new URLSearchParams()
      
      Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          params.append(key, value)
        }
      })

      const { data } = await api.get(`/home/query-products?${params.toString()}`)
      return fulfillWithValue(data)
    } catch (error) {
      // Use optional chaining to avoid errors if response doesn't exist
      return rejectWithValue(error.response?.data || { message: 'Network error' })
    }
  }
)
// End Method

export const product_details = createAsyncThunk(
  'product/product_details',
  async (slug, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/home/product-details/${slug}`)
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const get_discount_products = createAsyncThunk(
  'product/get_discount_products',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/get-discount-products', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_new_products = createAsyncThunk(
  'product/get_new_products',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/get-new-products', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const submit_review = createAsyncThunk(
  'review/submit_review',
  async (info, { fulfillWithValue }) => {
    try {
      const { data } = await api.post('/home/customer/submit-review', info)
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const submit_address = createAsyncThunk(
  'address/submit-address',
  async (info, { fulfillWithValue }) => {
    try {
      console.log(info)

      const { data } = await api.post('/home/customer/submit-address', info)
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const get_address = createAsyncThunk(
  'address/get_address',
  async ({ userId }, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/home/get-address/${userId}`)
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const get_reviews = createAsyncThunk(
  'review/get_reviews',
  async ({ productId, pageNumber }, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        `/home/customer/get-reviews/${productId}?pageNo=${pageNumber}`
      )
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const get_banners = createAsyncThunk(
  'banner/get_banners',
  async (_, { fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/banners`)
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.respone)
    }
  }
)
// End Method

export const get_sub_categories = createAsyncThunk(
  'category/get_sub_categories',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/get-subCategories', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method



export const get_categories_subCategories = createAsyncThunk(
  'category/get_categories_subCategories',
  async ({ categoryId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/home/get-categories-subCategories', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const homeReducer = createSlice({
  name: 'home',
  initialState: {
    loading: false,
    categorys: [],
    categoriesView: [],
    products: [],
    discountProducts: [],
    totalProduct: 0,
    parPage: 3,
    latest_product: [],
    topRated_product: [],
    discount_product: [],
    newProducts:[],
    priceRange: {
      low: 0,
      high: 100,
    },
    product: {},
    relatedProducts: [],
    moreProducts: [],
    errorMessage: '',
    successMessage: '',
    totalReview: 0,
    rating_review: [],
    reviews: [],
    banners: [],
    address: {},
    addresses: [],
    subCategories: [],
    categories: [],
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(get_category.fulfilled, (state, { payload }) => {
        state.categorys = payload.categorys
        state.loader = false
      })
      .addCase(get_category.rejected, (state, { payload }) => {
  state.errorMessage = payload?.error || 'Failed to fetch categories';
  state.loader = false;
})
      .addCase(get_categories.fulfilled, (state, { payload }) => {
        state.categoriesView = payload?.categoriesView
        state.loader = false
      })
      .addCase(get_categories.rejected, (state, { payload }) => {
  state.errorMessage = payload?.error || 'Failed to fetch categories view';
  state.loader = false;
})

      .addCase(get_products.fulfilled, (state, { payload }) => {
        state.products = payload.products
        state.latest_product = payload.latest_product
        state.topRated_product = payload.topRated_product
        state.discount_product = payload.discount_product
        state.loader = false
      })
      .addCase(price_range_product.fulfilled, (state, { payload }) => {
        state.latest_product = payload.latest_product
        state.priceRange = payload.priceRange
        state.loader = false
      })

      .addCase(query_products.pending, (state, { payload }) => {
        state.loader = true
        state.errorMessage = null;
      })

      .addCase(query_products.fulfilled, (state, { payload }) => {
        state.products = payload.products
        state.totalProduct = payload.totalProduct
        state.parPage = payload.parPage
          state.loader = false
      })

      .addCase(query_products.rejected, (state, { payload }) => {
        state.errorMessage = payload.error
        state.loader = false
      })

      .addCase(product_details.fulfilled, (state, { payload }) => {
        state.product = payload.product
        state.relatedProducts = payload.relatedProducts
        state.moreProducts = payload.moreProducts
        state.loader = false
      })

      .addCase(get_discount_products.fulfilled, (state, { payload }) => {
        state.totalProduct = payload.totalProduct
        state.discountProducts = payload.discountProducts
        state.loader = false
      })

      .addCase(get_new_products.fulfilled, (state, { payload }) => {
                state.newProducts = payload.newProducts
                state.loader = false
      })

      .addCase(submit_review.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message
        state.loader = false
      })

      .addCase(submit_address.rejected, (state, { payload }) => {
        state.errorMessage = payload.error
        state.loader = false
      })

      .addCase(submit_address.fulfilled, (state, { payload }) => {
        state.successMessage = payload?.message
        state.loader = false
      })

      .addCase(get_address.fulfilled, (state, { payload }) => {
        state.addresses = payload?.addresses || [];
        state.loader = false
      })

      .addCase(get_reviews.fulfilled, (state, { payload }) => {
        state.reviews = payload.reviews
        state.totalReview = payload.totalReview
        state.rating_review = payload.rating_review
        state.loader = false
      })

      .addCase(get_banners.fulfilled, (state, { payload }) => {
        state.banners = payload.banners
        state.loader = false
      })
      .addCase(get_categories_subCategories.fulfilled, (state, { payload }) => {
        state.categories = payload.categories
        state.loader = false
      })

      .addCase(get_sub_categories.fulfilled, (state, { payload }) => {
        state.subCategories = payload.subCategories
        state.loader = false
      })
  },
})
export const { messageClear } = homeReducer.actions
export default homeReducer.reducer
